import React from "react"
import { Router } from "@reach/router"

// substranky
import MyEbikeList from "../../components/pages/MyEbikeList/myebike-list"

export default function MyEbikePage(props) {
  return (
    <Router>
      <MyEbikeList path="/myebike" />
    </Router>
  )
}
